/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Results will appear here`)
};

const es_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los resultados aparecerán aquí`)
};

const de_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse erscheinen hier`)
};

const nl_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultaten verschijnen hier`)
};

const fr_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les résultats apparaîtront ici`)
};

const it_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I risultati appariranno qui`)
};

const pt_br2_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os resultados aparecerão aqui`)
};

const pt_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os resultados aparecerão aqui`)
};

const ja_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここに結果が表示されます`)
};

const zh_rg_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结果将显示在这里`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_empty", locale)
	if (locale === "en") return en_rg_empty(inputs)
	if (locale === "es") return es_rg_empty(inputs)
	if (locale === "de") return de_rg_empty(inputs)
	if (locale === "nl") return nl_rg_empty(inputs)
	if (locale === "fr") return fr_rg_empty(inputs)
	if (locale === "it") return it_rg_empty(inputs)
	if (locale === "pt-BR") return pt_br2_rg_empty(inputs)
	if (locale === "pt") return pt_rg_empty(inputs)
	if (locale === "ja") return ja_rg_empty(inputs)
	return zh_rg_empty(inputs)
};